import _taggedTemplateLiteral from "/home/runner/work/hitlabel.jp/hitlabel.jp/typescript/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _slicedToArray from "/home/runner/work/hitlabel.jp/hitlabel.jp/typescript/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/hitlabel.jp/hitlabel.jp/typescript/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/hitlabel.jp/hitlabel.jp/typescript/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var W = function W(e) {
  return typeof e == "function";
},
    T = function T(e, t) {
  return W(e) ? e(t) : e;
};

var U = function () {
  var e = 0;
  return function () {
    return (++e).toString();
  };
}(),
    b = function () {
  var e;
  return function () {
    if (e === void 0 && typeof window < "u") {
      var t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }

    return e;
  };
}();

import { useEffect as H, useState as j } from "react";
var Q = 20;

var S = new Map(),
    X = 1e3,
    $ = function $(e) {
  if (S.has(e)) return;
  var t = setTimeout(function () {
    S.delete(e), u({
      type: 4,
      toastId: e
    });
  }, X);
  S.set(e, t);
},
    J = function J(e) {
  var t = S.get(e);
  t && clearTimeout(t);
},
    v = function v(e, t) {
  switch (t.type) {
    case 0:
      return _objectSpread(_objectSpread({}, e), {}, {
        toasts: [t.toast].concat(_toConsumableArray(e.toasts)).slice(0, Q)
      });

    case 1:
      return t.toast.id && J(t.toast.id), _objectSpread(_objectSpread({}, e), {}, {
        toasts: e.toasts.map(function (r) {
          return r.id === t.toast.id ? _objectSpread(_objectSpread({}, r), t.toast) : r;
        })
      });

    case 2:
      var o = t.toast;
      return e.toasts.find(function (r) {
        return r.id === o.id;
      }) ? v(e, {
        type: 1,
        toast: o
      }) : v(e, {
        type: 0,
        toast: o
      });

    case 3:
      var s = t.toastId;
      return s ? $(s) : e.toasts.forEach(function (r) {
        $(r.id);
      }), _objectSpread(_objectSpread({}, e), {}, {
        toasts: e.toasts.map(function (r) {
          return r.id === s || s === void 0 ? _objectSpread(_objectSpread({}, r), {}, {
            visible: !1
          }) : r;
        })
      });

    case 4:
      return t.toastId === void 0 ? _objectSpread(_objectSpread({}, e), {}, {
        toasts: []
      }) : _objectSpread(_objectSpread({}, e), {}, {
        toasts: e.toasts.filter(function (r) {
          return r.id !== t.toastId;
        })
      });

    case 5:
      return _objectSpread(_objectSpread({}, e), {}, {
        pausedAt: t.time
      });

    case 6:
      var a = t.time - (e.pausedAt || 0);
      return _objectSpread(_objectSpread({}, e), {}, {
        pausedAt: void 0,
        toasts: e.toasts.map(function (r) {
          return _objectSpread(_objectSpread({}, r), {}, {
            pauseDuration: r.pauseDuration + a
          });
        })
      });
  }
},
    A = [],
    P = {
  toasts: [],
  pausedAt: void 0
},
    u = function u(e) {
  P = v(P, e), A.forEach(function (t) {
    t(P);
  });
},
    Y = {
  blank: 4e3,
  error: 4e3,
  success: 2e3,
  loading: 1 / 0,
  custom: 4e3
},
    I = function I() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _j = j(P),
      _j2 = _slicedToArray(_j, 2),
      t = _j2[0],
      o = _j2[1];

  H(function () {
    return A.push(o), function () {
      var a = A.indexOf(o);
      a > -1 && A.splice(a, 1);
    };
  }, [t]);
  var s = t.toasts.map(function (a) {
    var r, c;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, e), e[a.type]), a), {}, {
      duration: a.duration || ((r = e[a.type]) == null ? void 0 : r.duration) || (e == null ? void 0 : e.duration) || Y[a.type],
      style: _objectSpread(_objectSpread(_objectSpread({}, e.style), (c = e[a.type]) == null ? void 0 : c.style), a.style)
    });
  });
  return _objectSpread(_objectSpread({}, t), {}, {
    toasts: s
  });
};

var G = function G(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blank";
  var o = arguments.length > 2 ? arguments[2] : undefined;
  return _objectSpread(_objectSpread({
    createdAt: Date.now(),
    visible: !0,
    type: t,
    ariaProps: {
      role: "status",
      "aria-live": "polite"
    },
    message: e,
    pauseDuration: 0
  }, o), {}, {
    id: (o == null ? void 0 : o.id) || U()
  });
},
    h = function h(e) {
  return function (t, o) {
    var s = G(t, e, o);
    return u({
      type: 2,
      toast: s
    }), s.id;
  };
},
    n = function n(e, t) {
  return h("blank")(e, t);
};

n.error = h("error");
n.success = h("success");
n.loading = h("loading");
n.custom = h("custom");

n.dismiss = function (e) {
  u({
    type: 3,
    toastId: e
  });
};

n.remove = function (e) {
  return u({
    type: 4,
    toastId: e
  });
};

n.promise = function (e, t, o) {
  var s = n.loading(t.loading, _objectSpread(_objectSpread({}, o), o == null ? void 0 : o.loading));
  return e.then(function (a) {
    return n.success(T(t.success, a), _objectSpread(_objectSpread({
      id: s
    }, o), o == null ? void 0 : o.success)), a;
  }).catch(function (a) {
    n.error(T(t.error, a), _objectSpread(_objectSpread({
      id: s
    }, o), o == null ? void 0 : o.error));
  }), e;
};

import { useEffect as K, useCallback as L } from "react";

var Z = function Z(e, t) {
  u({
    type: 1,
    toast: {
      id: e,
      height: t
    }
  });
},
    ee = function ee() {
  u({
    type: 5,
    time: Date.now()
  });
},
    D = function D(e) {
  var _I = I(e),
      t = _I.toasts,
      o = _I.pausedAt;

  K(function () {
    if (o) return;
    var r = Date.now(),
        c = t.map(function (i) {
      if (i.duration === 1 / 0) return;
      var d = (i.duration || 0) + i.pauseDuration - (r - i.createdAt);

      if (d < 0) {
        i.visible && n.dismiss(i.id);
        return;
      }

      return setTimeout(function () {
        return n.dismiss(i.id);
      }, d);
    });
    return function () {
      c.forEach(function (i) {
        return i && clearTimeout(i);
      });
    };
  }, [t, o]);
  var s = L(function () {
    o && u({
      type: 6,
      time: Date.now()
    });
  }, [o]),
      a = L(function (r, c) {
    var _g$filter;

    var _ref = c || {},
        _ref$reverseOrder = _ref.reverseOrder,
        i = _ref$reverseOrder === void 0 ? !1 : _ref$reverseOrder,
        _ref$gutter = _ref.gutter,
        d = _ref$gutter === void 0 ? 8 : _ref$gutter,
        p = _ref.defaultPosition,
        g = t.filter(function (m) {
      return (m.position || p) === (r.position || p) && m.height;
    }),
        E = g.findIndex(function (m) {
      return m.id === r.id;
    }),
        x = g.filter(function (m, R) {
      return R < E && m.visible;
    }).length;

    return (_g$filter = g.filter(function (m) {
      return m.visible;
    })).slice.apply(_g$filter, _toConsumableArray(i ? [x + 1] : [0, x])).reduce(function (m, R) {
      return m + (R.height || 0) + d;
    }, 0);
  }, [t]);
  return {
    toasts: t,
    handlers: {
      updateHeight: Z,
      startPause: ee,
      endPause: s,
      calculateOffset: a
    }
  };
};

import * as l from "react";
import { styled as B, keyframes as z } from "goober";
import * as y from "react";
import { styled as C, keyframes as me } from "goober";
import { styled as te, keyframes as k } from "goober";

var oe = k(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]))),
    re = k(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]))),
    se = k(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]))),
    _ = te("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"])), function (e) {
  return e.primary || "#ff4b4b";
}, oe, re, function (e) {
  return e.secondary || "#fff";
}, se);

import { styled as ae, keyframes as ie } from "goober";
var ne = ie(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]))),
    V = ae("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"])), function (e) {
  return e.secondary || "#e0e0e0";
}, function (e) {
  return e.primary || "#616161";
}, ne);
import { styled as ce, keyframes as N } from "goober";
var pe = N(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]))),
    de = N(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]))),
    w = ce("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"])), function (e) {
  return e.primary || "#61d345";
}, pe, de, function (e) {
  return e.secondary || "#fff";
});

var ue = C("div")(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n"]))),
    le = C("div")(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]))),
    Te = me(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]))),
    fe = C("div")(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"])), Te),
    M = function M(_ref2) {
  var e = _ref2.toast;
  var t = e.icon,
      o = e.type,
      s = e.iconTheme;
  return t !== void 0 ? typeof t == "string" ? y.createElement(fe, null, t) : t : o === "blank" ? null : y.createElement(le, null, y.createElement(V, _objectSpread({}, s)), o !== "loading" && y.createElement(ue, null, o === "error" ? y.createElement(_, _objectSpread({}, s)) : y.createElement(w, _objectSpread({}, s))));
};

var ye = function ye(e) {
  return "\n0% {transform: translate3d(0,".concat(e * -200, "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n");
},
    ge = function ge(e) {
  return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0,".concat(e * -150, "%,-1px) scale(.6); opacity:0;}\n");
},
    he = "0%{opacity:0;} 100%{opacity:1;}",
    xe = "0%{opacity:1;} 100%{opacity:0;}",
    be = B("div")(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]))),
    Se = B("div")(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]))),
    Ae = function Ae(e, t) {
  var s = e.includes("top") ? 1 : -1,
      _ref3 = b() ? [he, xe] : [ye(s), ge(s)],
      _ref4 = _slicedToArray(_ref3, 2),
      a = _ref4[0],
      r = _ref4[1];

  return {
    animation: t ? "".concat(z(a), " 0.35s cubic-bezier(.21,1.02,.73,1) forwards") : "".concat(z(r), " 0.4s forwards cubic-bezier(.06,.71,.55,1)")
  };
},
    F = l.memo(function (_ref5) {
  var e = _ref5.toast,
      t = _ref5.position,
      o = _ref5.style,
      s = _ref5.children;
  var a = e.height ? Ae(e.position || t || "top-center", e.visible) : {
    opacity: 0
  },
      r = l.createElement(M, {
    toast: e
  }),
      c = l.createElement(Se, _objectSpread({}, e.ariaProps), T(e.message, e));
  return l.createElement(be, {
    className: e.className,
    style: _objectSpread(_objectSpread(_objectSpread({}, a), o), e.style)
  }, typeof s == "function" ? s({
    icon: r,
    message: c
  }) : l.createElement(l.Fragment, null, r, c));
});

import { css as Pe, setup as Oe } from "goober";
import * as f from "react";
Oe(f.createElement);

var Ee = function Ee(_ref6) {
  var e = _ref6.id,
      t = _ref6.className,
      o = _ref6.style,
      s = _ref6.onHeightUpdate,
      a = _ref6.children;
  var r = f.useCallback(function (c) {
    if (c) {
      var i = function i() {
        var d = c.getBoundingClientRect().height;
        s(e, d);
      };

      i(), new MutationObserver(i).observe(c, {
        subtree: !0,
        childList: !0,
        characterData: !0
      });
    }
  }, [e, s]);
  return f.createElement("div", {
    ref: r,
    className: t,
    style: o
  }, a);
},
    Re = function Re(e, t) {
  var o = e.includes("top"),
      s = o ? {
    top: 0
  } : {
    bottom: 0
  },
      a = e.includes("center") ? {
    justifyContent: "center"
  } : e.includes("right") ? {
    justifyContent: "flex-end"
  } : {};
  return _objectSpread(_objectSpread({
    left: 0,
    right: 0,
    display: "flex",
    position: "absolute",
    transition: b() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
    transform: "translateY(".concat(t * (o ? 1 : -1), "px)")
  }, s), a);
},
    ve = Pe(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]))),
    O = 16,
    Ie = function Ie(_ref7) {
  var e = _ref7.reverseOrder,
      _ref7$position = _ref7.position,
      t = _ref7$position === void 0 ? "top-center" : _ref7$position,
      o = _ref7.toastOptions,
      s = _ref7.gutter,
      a = _ref7.children,
      r = _ref7.containerStyle,
      c = _ref7.containerClassName;

  var _D = D(o),
      i = _D.toasts,
      d = _D.handlers;

  return f.createElement("div", {
    style: _objectSpread({
      position: "fixed",
      zIndex: 9999,
      top: O,
      left: O,
      right: O,
      bottom: O,
      pointerEvents: "none"
    }, r),
    className: c,
    onMouseEnter: d.startPause,
    onMouseLeave: d.endPause
  }, i.map(function (p) {
    var g = p.position || t,
        E = d.calculateOffset(p, {
      reverseOrder: e,
      gutter: s,
      defaultPosition: t
    }),
        x = Re(g, E);
    return f.createElement(Ee, {
      id: p.id,
      key: p.id,
      onHeightUpdate: d.updateHeight,
      className: p.visible ? ve : "",
      style: x
    }, p.type === "custom" ? T(p.message, p) : a ? a(p) : f.createElement(F, {
      toast: p,
      position: g
    }));
  }));
};

var _t = n;
export { w as CheckmarkIcon, _ as ErrorIcon, V as LoaderIcon, F as ToastBar, M as ToastIcon, Ie as Toaster, _t as default, T as resolveValue, n as toast, D as useToaster, I as useToasterStore };